module.exports = __webpack_public_path__ + "videos/globe_10s.dfa3613.mp4";